import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, FornecedorSelecionado } from './types';

export const INITIAL_STATE: FornecedorSelecionado = {
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): FornecedorSelecionado {
	return produce(state, draft => {
		switch (action.type) {
			case Types.FORNECEDOR_SELECIONADO_REQUEST: {
				draft.data = action.payload;
				break;
			}
			case Types.FORNECEDOR_SELECIONADO_CLEAR: {
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
